// Loom Loom free-shipping bar: keeps the message and progress in sync with the cart,
// and tells the sticky header how tall the bar is so it sits right below it.
(() => {
  const bar = document.querySelector('[data-ll-shipbar]');
  if (!bar) return;
  const root = window.Shopify?.routes?.root || '/';
  const msg = bar.querySelector('[data-ll-shipbar-msg]');
  const fill = bar.querySelector('[data-ll-shipbar-fill]');
  const rate = parseFloat(window.Shopify?.currency?.rate || '1') || 1;
  const threshold = Math.round(+bar.dataset.threshold * rate);
  const currency = window.Shopify?.currency?.active || bar.dataset.currency || 'USD';

  const fmt = (cents) => new Intl.NumberFormat(undefined, {
    style: 'currency', currency,
    minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(cents / 100);
  const esc = (s) => s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  function render(total) {
    const left = threshold - total;
    if (total <= 0) {
      msg.textContent = bar.dataset.msgEmpty.replace('[threshold]', fmt(threshold));
    } else if (left > 0) {
      msg.innerHTML = esc(bar.dataset.msgProgress).replace('[amount]', `<span class="ll-shipbar__amount">${fmt(left)}</span>`);
    } else {
      msg.textContent = bar.dataset.msgDone;
    }
    if (fill) fill.style.width = `${threshold > 0 ? Math.min(100, (total / threshold) * 100) : 100}%`;
  }

  let timer;
  const refresh = () => {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      try {
        const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
        render(cart.total_price);
      } catch (e) { /* keep the last message */ }
    }, 150);
  };

  // Any cart change on the page, whichever theme code or app makes it
  const isCartWrite = (url) => /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url));
  const origFetch = window.fetch;
  window.fetch = function (input, init) {
    const p = origFetch.apply(this, arguments);
    if (isCartWrite(input && input.url ? input.url : input)) p.then(refresh, refresh);
    return p;
  };
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartWrite(url)) this.addEventListener('loadend', refresh);
    return origOpen.apply(this, arguments);
  };
  document.addEventListener('cart:refresh', refresh);
  document.documentElement.addEventListener('cart:updated', refresh);
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  // Back/forward cache can show a stale cart
  window.addEventListener('pageshow', (e) => { if (e.persisted) refresh(); });

  // Sticky header offset
  const section = bar.closest('.shopify-section') || bar;
  const setHeight = () => document.documentElement.style.setProperty('--ll-shipbar-h', `${section.offsetHeight}px`);
  setHeight();
  if ('ResizeObserver' in window) new ResizeObserver(setHeight).observe(section);
  else window.addEventListener('resize', setHeight);

  refresh();
})();